import { ApiProperty } from "@nestjs/swagger";

export class SOTransferDto{
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    fromUnit: number;
    @ApiProperty()
    toUnit: number;
    @ApiProperty()
    fromProcessingUnit: number;
    @ApiProperty()
    toProcessingUnit: number;
    @ApiProperty()
    stockConversionStatus?: boolean;
}